var ExternalIntegration = {

    load: function() {
        jQuery('.external-integration-content').each(function() {
            var placeholder = jQuery(this);
            var logged_person_id = jQuery('body').attr('data-person-id');
            var content = sessionStorage.getItem('external-integration-' + logged_person_id + '-' + placeholder.attr('data-url'));

            if (content) {
                jQuery(this).replaceWith(content);
            } else {
                jQuery.ajax({
                    url: placeholder.attr('data-url'),
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function(content) {
                    sessionStorage.setItem('external-integration-' + logged_person_id + '-' + placeholder.attr('data-url'), content);
                    placeholder.replaceWith(content);
                });
            }
        });
    }
}

window.ExternalIntegration = ExternalIntegration;